module.exports = __webpack_public_path__ + "img/67.08e2e5d7.svg";